"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenDtoToJSON = exports.TokenDtoFromJSONTyped = exports.TokenDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function TokenDtoFromJSON(json) {
    return TokenDtoFromJSONTyped(json, false);
}
exports.TokenDtoFromJSON = TokenDtoFromJSON;
function TokenDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accessToken': !runtime_1.exists(json, 'accessToken') ? undefined : json['accessToken'],
        'expiresIn': !runtime_1.exists(json, 'expiresIn') ? undefined : json['expiresIn'],
    };
}
exports.TokenDtoFromJSONTyped = TokenDtoFromJSONTyped;
function TokenDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accessToken': value.accessToken,
        'expiresIn': value.expiresIn,
    };
}
exports.TokenDtoToJSON = TokenDtoToJSON;
